// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33ab8","field":"styles_field__3ty4t","fieldCol":"styles_fieldCol__3PhDx","diffCol":"styles_diffCol__Pj1_G","diff":"styles_diff__3CZOX"};